import React from "react";
import PropTypes from "prop-types";
import "./TimeSlotInfoCard.scss";

function TimeSlotInfoCard({ label, value, className = "" }) {
  return (
    <div className={`timeslot-info-card ${className}`}>
      <p className="heading-h5-medium timeslot-info-card__label">{label}</p>
      <p className="heading-h5-regular timeslot-info-card__value">{value}</p>
    </div>
  );
}

TimeSlotInfoCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
};

TimeSlotInfoCard.defaultProps = {
  className: "",
};

export default TimeSlotInfoCard;
